import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/pages.css';

function NotFound() {
  return (
    <div>
      <section className="hero">
        <div className="container">
          <h1>404 - Page Not Found</h1>
          <p>The page you're looking for doesn't exist</p>
        </div>
      </section>
      <section className="section">
        <div className="container" style={{textAlign: 'center'}}>
          <p style={{fontSize: '1.2rem', marginBottom: '30px'}}>
            Sorry, we couldn't find the page you were looking for.
          </p>
          <Link to="/">
            <button className="btn btn-primary">Go Back Home</button>
          </Link>
        </div>
      </section>
    </div>
  );
}

export default NotFound;
